export default __webpack_public_path__ + "static/media/info.45158504.svg";